// extracted by mini-css-extract-plugin
export default {"price-input":"_2nL5k","priceInput":"_2nL5k","premium-selected":"_1Ukoj","premiumSelected":"_1Ukoj","full-width":"_1MciQ","fullWidth":"_1MciQ"};